// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CopyDesignPackageCardsMutationVariables = Types.Exact<{
  input: Types.CopyDesignPackageCardsInput;
}>;


export type CopyDesignPackageCardsMutation = { __typename?: 'Mutation', copyDesignPackageCards: { __typename?: 'CopyDesignPackageCardsResult', targetPlaceholderTlis: Array<{ __typename?: 'TakeoffLineItem', id: string }>, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } } };

export type CopyDesignPackageCardsModalQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TakeoffLineItemFilter>;
  designPackageVersionId: Types.Scalars['ID']['input'];
}>;


export type CopyDesignPackageCardsModalQuery = { __typename?: 'Query', takeoffLineItemsPage: { __typename?: 'TakeoffLineItemsPage', items: Array<{ __typename?: 'TakeoffLineItem', active: boolean, id: string, name: string, location: { __typename?: 'Location', displayLocationPath: string, id: string, name: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined, personalizationOptionGroup?: { __typename?: 'ReadyPlanOptionGroup', id: string } | null | undefined }> } };

export type CopyDesignPackageCardsModal_TliFragment = { __typename?: 'TakeoffLineItem', active: boolean, id: string, name: string, location: { __typename?: 'Location', displayLocationPath: string, id: string, name: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined, personalizationOptionGroup?: { __typename?: 'ReadyPlanOptionGroup', id: string } | null | undefined };

export type CopyDesignPackageCardsModal_PlaceholderTliFragment = { __typename?: 'TakeoffLineItem', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string } };

export const CopyDesignPackageCardsModal_TliFragmentDoc = gql`
    fragment CopyDesignPackageCardsModal_TLI on TakeoffLineItem {
  ...Named
  active
  location {
    ...Named
    displayLocationPath
  }
  materialVariant {
    id
    code
  }
  personalizationOptionGroup {
    id
  }
}
    ${NamedFragmentDoc}`;
export const CopyDesignPackageCardsModal_PlaceholderTliFragmentDoc = gql`
    fragment CopyDesignPackageCardsModal_PlaceholderTli on TakeoffLineItem {
  id
  materialVariant {
    id
  }
  unitOfMeasure {
    id
  }
}
    `;
export const CopyDesignPackageCardsDocument = gql`
    mutation CopyDesignPackageCards($input: CopyDesignPackageCardsInput!) {
  copyDesignPackageCards(input: $input) {
    targetPlaceholderTlis {
      id
    }
    version {
      id
    }
  }
}
    `;
export type CopyDesignPackageCardsMutationFn = Apollo.MutationFunction<CopyDesignPackageCardsMutation, CopyDesignPackageCardsMutationVariables>;

/**
 * __useCopyDesignPackageCardsMutation__
 *
 * To run a mutation, you first call `useCopyDesignPackageCardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyDesignPackageCardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyDesignPackageCardsMutation, { data, loading, error }] = useCopyDesignPackageCardsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyDesignPackageCardsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopyDesignPackageCardsMutation, CopyDesignPackageCardsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopyDesignPackageCardsMutation, CopyDesignPackageCardsMutationVariables>(CopyDesignPackageCardsDocument, options);
      }
export type CopyDesignPackageCardsMutationHookResult = ReturnType<typeof useCopyDesignPackageCardsMutation>;
export type CopyDesignPackageCardsMutationResult = Apollo.MutationResult<CopyDesignPackageCardsMutation>;
export type CopyDesignPackageCardsMutationOptions = Apollo.BaseMutationOptions<CopyDesignPackageCardsMutation, CopyDesignPackageCardsMutationVariables>;
export const CopyDesignPackageCardsModalDocument = gql`
    query CopyDesignPackageCardsModal($filter: TakeoffLineItemFilter, $designPackageVersionId: ID!) {
  takeoffLineItemsPage(versionId: $designPackageVersionId, filter: $filter) {
    items {
      ...CopyDesignPackageCardsModal_TLI
    }
  }
}
    ${CopyDesignPackageCardsModal_TliFragmentDoc}`;

/**
 * __useCopyDesignPackageCardsModalQuery__
 *
 * To run a query within a React component, call `useCopyDesignPackageCardsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopyDesignPackageCardsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopyDesignPackageCardsModalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      designPackageVersionId: // value for 'designPackageVersionId'
 *   },
 * });
 */
export function useCopyDesignPackageCardsModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CopyDesignPackageCardsModalQuery, CopyDesignPackageCardsModalQueryVariables> & ({ variables: CopyDesignPackageCardsModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CopyDesignPackageCardsModalQuery, CopyDesignPackageCardsModalQueryVariables>(CopyDesignPackageCardsModalDocument, options);
      }
export function useCopyDesignPackageCardsModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CopyDesignPackageCardsModalQuery, CopyDesignPackageCardsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CopyDesignPackageCardsModalQuery, CopyDesignPackageCardsModalQueryVariables>(CopyDesignPackageCardsModalDocument, options);
        }
export function useCopyDesignPackageCardsModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CopyDesignPackageCardsModalQuery, CopyDesignPackageCardsModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CopyDesignPackageCardsModalQuery, CopyDesignPackageCardsModalQueryVariables>(CopyDesignPackageCardsModalDocument, options);
        }
export type CopyDesignPackageCardsModalQueryHookResult = ReturnType<typeof useCopyDesignPackageCardsModalQuery>;
export type CopyDesignPackageCardsModalLazyQueryHookResult = ReturnType<typeof useCopyDesignPackageCardsModalLazyQuery>;
export type CopyDesignPackageCardsModalSuspenseQueryHookResult = ReturnType<typeof useCopyDesignPackageCardsModalSuspenseQuery>;
export type CopyDesignPackageCardsModalQueryResult = Apollo.QueryResult<CopyDesignPackageCardsModalQuery, CopyDesignPackageCardsModalQueryVariables>;